import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const podcast = {
  createPodcast: lazyModuleMethod(() => import('./createPodcast'), 'default'),
  fetchPodcast: lazyModuleMethod(() => import('./fetchPodcast'), 'default'),
  fetchPodcasts: lazyModuleMethod(() => import('./fetchPodcasts'), 'default'),
  updatePodcast: lazyModuleMethod(() => import('./updatePodcast'), 'default'),
}
